import EventTable from "components/eventTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchUserProfile } from "services/users";
import WebSocketEventEmitter from "../../context/eventEmitter";
import { fetchSportsEvents, fetchSportsEventsBeforeLogin } from "../../redux/slice/events/eventsSlice";
import Cricket from "components/cricket";
function IPL() {
    const iplTeams = [
        "Chennai Super Kings",
        "Delhi Capitals",
        "Gujarat Titans",
        "Kolkata Knight Riders",
        "Lucknow Super Giants",
        "Mumbai Indians",
        "Punjab Kings",
        "Rajasthan Royals",
        "Royal Challengers Bengaluru",
        "Sunrisers Hyderabad"
    ]

    const dispatch = useDispatch();
    const { cricketEvents, soccerEvents, tennisEvents, loading, events } = useSelector((state) => state.events);
    const profileData = useSelector((state) => state.authSlice.profileData);
    const { isAuthenticated } = useSelector((state) => state.authSlice);
    const [iplMatches, setIplMatches] = useState([]);
    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchSportsEvents());
        }
        else {
            dispatch(fetchSportsEventsBeforeLogin())
        }
    }, [isAuthenticated, dispatch]);


    useEffect(() => {
        const handleMessage = async (data) => {
            if (data.action == "USER_BLOCK_UPDATE") {
                let market = data.data;
                console.log("user block Details SOCKET RESPONDING");
                if (market) {
                    const profileResponse = await fetchUserProfile();
                    console.log('profileResponse', profileResponse)
                    // dispatch(setProfileData(profileResponse?.data?.data));
                }
            }
        };

        WebSocketEventEmitter.on("message", handleMessage);

        return () => {
            WebSocketEventEmitter.off("message", handleMessage); // Cleanup on unmount
        };
    }, [profileData, dispatch])

    useEffect(() => {
        if (!cricketEvents || cricketEvents.length === 0) return;

        const filtered = cricketEvents.filter(event => {
            const [team1, team2] = event.event_name.split(" v ");
            return iplTeams.includes(team1?.trim()) && iplTeams.includes(team2?.trim());
        });

        setIplMatches(filtered);
    }, [cricketEvents]);
    console.log('iplMatches', iplMatches)
    return (
        <div className="relative w-full">
            <div className="grid grid-cols-12 px-[6px]">
                <div className='col-span-12 mb-[7px]'>
                    <img alt="" src="/assets/images/banner/Cricket-banner.jpg" />
                </div>
                <div className='col-span-12 '>
                    <Cricket title={"Indian Premier League"} events={iplMatches} />
                </div>
            </div>
        </div>
    );
}

export default IPL;